import { useMemo } from 'react';

export const useShowIconColumn = (
  employments: {
    hasFokParameterChoices: boolean;
    isInactive?: boolean;
  }[]
): boolean => {
  const showIconColumn = useMemo(
    () => employments.some(emp => emp.isInactive || emp.hasFokParameterChoices),
    [employments]
  );
  return showIconColumn;
};
